import React, { useEffect, useState } from "react";
import Form from 'olive-react-myoneui/lib/Form';
import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
import Button from 'olive-react-myoneui/lib/Button';
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import CircleImageContent from "olive-react-myoneui/lib/CircleImageContent";
import { chatIcon, heartIcon, heartFilledIcon, replyIcon } from "../../../constants/icons";
import { formatDaysAgo } from "../../../../helpers/datetime_helper";
import { Global, likeOnComment, showReplyComments, replyComment } from "../../../../api/afterLogin/newsFeed";
import { numberToShortForm, pluralize } from "../../../../helpers/string_helper";

const CommentBlock = ({ className, userProfle, commentId, commentImage, commentName, comment, numberOfLikes, numberOfReplies, createdAt, likedByUser, newsFeedApiUrl, newsFeedLunchUrl, newsFeedClientId, postTotalComments  }) => {
    const [liked, setLiked] = useState(false);
    const [showReply, setShowReply] = useState(false);
    const [replyComments, setReplyComments] = useState([]);
    const [totalLiked, setTotalLiked] = useState(numberOfLikes);
    const [commentLikedByUser, setCommentLikedByUser] = useState(likedByUser);
    const [totalReplies, setTotalReplies] = useState(numberOfReplies);
    const [replyCommentsText, setReplyCommentsText] = useState('');

    const handleClickLike = () => {
        setLiked(prev => !prev);
    };

    const likeOnCommentHandle = async (e) => {
        e.preventDefault();
        let params = {
            commentID: commentId,
            newsFeedApiUrl: newsFeedApiUrl,
            newsFeedLunchUrl: newsFeedLunchUrl,
            newsFeedClientId: newsFeedClientId
        };
        if (typeof likeOnCommentHandle === "function") {
            try {
                const response = await likeOnComment(params);
                let isRevoked  = response.data.isRevoked === false;
                setTotalLiked((prevTotalLiked) => isRevoked ? prevTotalLiked + 1 : prevTotalLiked - 1);
                setCommentLikedByUser(isRevoked)
            } catch (error) {
                console.log(error);
            }
        }
    }

    const showReplyCommentsHandle = async (e) => {
        e.preventDefault();
        if (showReply === true) {
            setShowReply(false);
        } else {
            let params = {
                commentID: commentId,
                newsFeedApiUrl: newsFeedApiUrl,
                newsFeedLunchUrl: newsFeedLunchUrl,
            };
            try {
                const response = await showReplyComments(params);
                if (response && response.data)
                {
                    setShowReply(true);
                    setReplyComments(response.data)
                }
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleReplyChange = (e) => {
        setReplyCommentsText(e.target.value);
    };

    const postReply = (commentId) => {
        const socket = Global.getSocket();
        try {
            setReplyCommentsText('');
            if (replyCommentsText.trim().length == 0) {
              alert('Message is empty');
            } else {
              let payload = {
                newsFeedClientId: newsFeedClientId,
                replyDescription: replyCommentsText,
                id: commentId,
                urlParams: newsFeedLunchUrl,
              };
              if (socket) {
                socket.emit('reply', payload);
              }
            }
        } catch (error) {
            console.log(error);
        }
    }
    
    const onReply = () => {
        const socket = Global.getSocket();
        try {
            socket.on('reply', async (response) => {
                let replyData = Object.assign({}, response.data);
                delete replyData.totalReplies;
        
                if (
                    replyData.newsFeedClient === newsFeedClientId &&
                    replyData.newsFeedComment === commentId
                ) {
                    let repliedComments = [...replyComments];
                    repliedComments.unshift(replyData);
                    setReplyComments(repliedComments);
                    setTotalReplies(response.data.totalReplies)
                }
            });
        } catch (error) {
            console.log(error);
        }
    }


    useEffect(() => {
        const socket = Global.getSocket();
        if (socket) {
            onReply()
        }
        
        return () => {
            socket.off("reply");
        }
    });

    return (
        <div className="myk__stu-comment-inner mb-4">
            <div className="information-wrap mb-3">
                <div className="information-holder align-items-start">
                    <CircleImage className="circle-wrap circle-wrap-sm">
                        {commentImage !== '' ? (<img src={commentImage} alt="Profile" />) : (<CircleImageContent svgImage={'two'} />) }
                    </CircleImage>
                    <div className="information-detail">
                        <h3>{commentName} <span className="time-commented">{formatDaysAgo(createdAt)}</span></h3>
                        <p>{comment}</p>
                    </div>
                </div>
            </div>
            <div className={`${className || ""} ps-5`}>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3">
                        <div className={`btn-reponse d-flex align-items-center justify-content-center gap-1 ${liked ? 'liked' : ''}`} onClick={likeOnCommentHandle}>
                            <div className="icon">{commentLikedByUser ? heartFilledIcon : heartIcon}</div>
                            <span className="flex-1">Like</span>
                        </div>
                        <div className="btn-reponse d-flex align-items-center gap-1" onClick={showReplyCommentsHandle}>
                            <div className="icon">{replyIcon}</div>
                            <span>Reply</span>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <span className="count-like">{numberToShortForm(totalLiked ?? 0)} {pluralize(totalLiked ?? 0,'Like')}</span>
                        <span className="count-like">{numberToShortForm(totalReplies ?? 0)} {(totalReplies > 1 ? 'Replies' : 'Reply')}</span>
                    </div>
                </div>
            </div>
            {showReply && replyComments.length > 0 && replyComments.map((reply, index) => (
                <div className="myk__stu-reply-field ms-5 mt-3">
                    <div className="information-wrap mb-0">
                        <div className="information-holder align-items-start" key={reply._id}>
                            <CircleImage className="circle-wrap circle-wrap-sm">
                                {reply !== '' ? (<img src={reply?.creator?.profilePic} alt="Profile" />) : (<CircleImageContent svgImage={'two'} />) }
                                <CircleImageContent svgImage={'two'} />
                            </CircleImage>
                            <div className="information-detail">
                                <h3>{reply?.creator?.name} <span className="time-commented">{formatDaysAgo(reply?.createdAt)}</span></h3>
                                <p>{reply?.replyDescription}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
            {showReply && (
                <div className="myk__stu-reply-field ms-5 mt-3">
                    <div className="information-wrap mb-0">
                        <div className="information-holder align-items-start">
                            <CircleImage className="circle-wrap circle-wrap-sm">
                                {userProfle && (<img src={userProfle} alt="Profile" />)}
                            </CircleImage>
                            <div className="information-detail">
                                <FloatingLabel className="w-100" label="Join the conversation">
                                    <Form.Control
                                        as="textarea"
                                        placeholder="Join the conversation"
                                        style={{ height: '72px' }}
                                        value={replyCommentsText ?? 'Reply Text Here'}
                                        onChange={handleReplyChange}
                                    />
                                </FloatingLabel>
                                <Button
                                    variant="primary"
                                    className="mt-2 btn-round text-white btn-sm px-4"
                                    type="button"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        // Handle posting reply logic here
                                        postReply(commentId); // Optionally close the reply field
                                    }}
                                >
                                    Post Reply
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CommentBlock;
